<template>
    <div class="formInput__wrapper">
        <button
            :id="fieldId"
            :type="fieldType"
            :name="fieldName"
            :class="fieldClasses"
            :disabled="fieldDisabled"
            :data-gtm="dataGtm"
            @click="handleClick">
            <template v-if="fieldValue">
                {{ fieldValue }}
            </template>
            <template v-else-if="fieldLabel">
                {{ fieldLabel }}
            </template>
            <slot></slot>
        </button>
    </div>
</template>

<script>
    import formBaseProps from 'mixins/formBaseMixin';
    import formInputProps from 'mixins/formInputMixin';

    export default {
        mixins: [formBaseProps, formInputProps],
        props: {
            dataGtm: { type: String, default: null },
        },
        methods: {
            handleClick(event) {
                this.$emit('click', event);
            },
        },
    };
</script>
